import { OptionCard, OptionCardGroup } from '@customerio/pluma-components/react';
import { DATA_CENTERS } from '@/utils/data-center';

export const DATA_CENTER_HEADING = 'Where are your customers?';

export const DATA_CENTER_DESCRIPTION =
  'We store your customer data in the region you pick. Consider any compliance regulations that apply to you, like GDPR.';

export const DATA_CENTER_PERMANENCE_NOTE = "You\u00a0can't change this later.";

type DataCenterOptionCardsProps = {
  value: string;
  onChange: (value: string) => void;
  /** Side by side (the data-center-only step) or stacked (the combined step). */
  isHorizontal?: boolean;
};

/** The single-select region cards, shared by the combined and data-center-only onboarding steps. */
export function DataCenterOptionCards({ value, onChange, isHorizontal = false }: DataCenterOptionCardsProps) {
  return (
    <OptionCardGroup
      ariaLabel={DATA_CENTER_HEADING}
      inputType="radio"
      cardsLayout={isHorizontal ? 'grid' : undefined}
      cardsColumns={isHorizontal ? 2 : undefined}
      cardsGap="150"
      value={value}
      onChange={onChange}
    >
      {DATA_CENTERS.map((option) => (
        <OptionCard
          key={option.value}
          value={option.value}
          title={`${option.flag} ${option.name}`}
          description={option.description}
          // The flag is decoration; the region name alone is the label.
          ariaLabel={option.name}
          w="full"
        />
      ))}
    </OptionCardGroup>
  );
}
